import styled from 'styled-components';

export const JackpotWidgetDefaultBox = styled.div<{isClickable?: boolean}>`
    cursor: ${({isClickable}) => isClickable ? "pointer" : "default"};

    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
`;
